import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const NearEndIndicator = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<path
				d="M9.5,4 C13.6421356,4 17,7.35786438 17,11.5 C17,15.6421356 13.6421356,19 9.5,19 C5.35786438,19 2,15.6421356 2,11.5 C2,7.35786438 5.35786438,4 9.5,4 Z M9.5,5 C5.91014913,5 3,7.91014913 3,11.5 C3,15.0898509 5.91014913,18 9.5,18 C13.0898509,18 16,15.0898509 16,11.5 C16,7.91014913 13.0898509,5 9.5,5 Z M7.34604359,10.6901448 L5.39961777,8.02677499 L8.75833051,10.2669728 C8.98840973,10.1673614 9.23994328,10.1108442 9.50627293,10.1108442 C10.5272032,10.1108442 11.3557843,10.9020841 11.3557843,11.8770046 C11.3557843,12.8519251 10.5272032,13.643165 9.50627293,13.643165 C8.48460282,13.643165 7.65676151,12.8519251 7.65676151,11.8770046 C7.65676151,11.6650653 7.69375173,11.4601907 7.76699239,11.2701519 L7.34604359,10.6901448 Z M16.1995006,3.5261745 L17.784162,5.04012716 C18.071946,5.31494172 18.071946,5.76425291 17.784162,6.03906747 L16.8571869,6.92426704 C16.5694029,7.1990816 16.0988872,7.1990816 15.8111032,6.92426704 L14.2264418,5.41031438 C13.9386579,5.13620629 13.9386579,4.68689509 14.2264418,4.41137407 L15.153417,3.5261745 C15.4412009,3.25206641 15.9124565,3.25206641 16.1995006,3.5261745 Z M10,0 C11.1045695,0 12,0.8954305 12,2 C12,3.1045695 11.1045695,4 10,4 C8.8954305,4 8,3.1045695 8,2 C8,0.8954305 8.8954305,0 10,0 Z M10,1 C9.44771525,1 9,1.44771525 9,2 C9,2.55228475 9.44771525,3 10,3 C10.5522847,3 11,2.55228475 11,2 C11,1.44771525 10.5522847,1 10,1 Z"
				id="nearEndIndicator"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

NearEndIndicator.propTypes = {
	color: PropTypes.string,
};

export default NearEndIndicator;
